import { useEffect, useMemo } from 'react';
import { buildSupportUrl, SupportTopic } from '../config/support';

/**
 * Public `/support` route. Performs a client-side redirect to the AI Support
 * Platform, preserving the incoming query string (solutionId, topic, app, and
 * optional analytics params). A real SPA cannot emit a 302, so this is the
 * "minimal info page + immediate redirect" alternative allowed by the contract.
 */
export default function SupportRedirect() {
  const target = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    const rawTopic = params.get('topic') ?? undefined;
    const topic = (['help', 'suggest', 'report'].includes(rawTopic ?? '')
      ? rawTopic
      : undefined) as SupportTopic | undefined;
    const platformParam = params.get('platform');
    const platform =
      platformParam === 'android' || platformParam === 'ios' || platformParam === 'web'
        ? platformParam
        : 'web';
    return buildSupportUrl({
      topic,
      orgId: params.get('solutionId') ?? undefined,
      platform,
      version: params.get('version') ?? undefined,
      locale: params.get('locale') ?? undefined,
    });
  }, []);

  useEffect(() => {
    window.location.replace(target);
  }, [target]);

  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 p-6 text-center">
      <p className="text-slate-600">Redirecting you to BirdMan support…</p>
      <a href={target} className="text-sky-600 underline">
        Continue to support
      </a>
    </div>
  );
}
